<template>
  <img src="~/assets/icon/card.svg" />
</template>
